import { render, staticRenderFns } from "./WaitForResource.vue?vue&type=template&id=15efc312&"
import script from "./WaitForResource.vue?vue&type=script&lang=js&"
export * from "./WaitForResource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports